import React from 'react'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import Footer from './footer'
import Slider from 'simple-react-slider'

import './career.scss'
import 'simple-react-slider/index.css'

const Career = ({
  primary,
  image,
  imageMobile,
  imageAbout,
  imageAboutMobile,
  imageAreaOne,
  imageAreaTwo,
  imageRoleOne,
  imageRoleTwo,
  imageRoleThree,
  imageRoleAlternateOne,
  imageRoleAlternateTwo,
  imageRoleAlternateThree,
  imageProfile,
  imageProfileMobile,
  imageProfileAlternate,
  imageProfileAlternateMobile,
  secondary,
  secondaryImageMobile,
  tertiary,
  tertiaryImageMobile,
}) => (
  <section
    className={secondary === null ? 'career expanded' : 'career multiple'}
  >
    {secondary !== null && (
      <div className="results-intro">
        <h1>Nice Work!</h1>
        <p className="description">
          Based on your answers, we found <strong>three career paths</strong>{' '}
          you may be interested in.
        </p>
      </div>
    )}
    <div className="primary-content">
      <div className="career-path">
        <Img
          fluid={imageMobile.childImageSharp.fluid}
          className="career-path-image hide-for-desktop"
        />
        <Img
          fluid={image.childImageSharp.fluid}
          className="career-path-image hide-for-mobile"
        />
        <div className="career-path-content">
          <h2>{primary.name}</h2>
          <p className="summary">{primary.summary}</p>
          <button
            className="btn btn-primary btn-fill explore-cta"
            onClick={event =>
              document
                .getElementsByClassName('career')[0]
                .classList.add('expanded') + '/index.html'
            }
          >
            Explore {primary.name}
          </button>
        </div>
      </div>
    </div>
    <div className="expanded-content">
      {primary.expanded !== '' && (
        <div className="expanded-summary">
          <Img
            fluid={imageAboutMobile.childImageSharp.fluid}
            className="about-field-image hide-for-desktop"
          />
          <Img
            fluid={imageAbout.childImageSharp.fluid}
            className="about-field-image hide-for-mobile"
          />
          <p>{primary.expanded}</p>
        </div>
      )}

      {primary.areas !== null && (
        <>
          <div className="areas-explained">
            <h3 className="eyebrow">
              {primary.name} at McKinsey falls into two main areas:
            </h3>
            <div className="area-list">
              <div className="area">
                <Img fluid={imageAreaOne.childImageSharp.fluid} />
                <div className="area-content">
                  <h4 className="area-title">{primary.areas[0].name}</h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: primary.areas[0].summary,
                    }}
                  />
                </div>
              </div>
              <div className="area">
                <Img fluid={imageAreaTwo.childImageSharp.fluid} />
                <div className="area-content">
                  <h4 className="area-title">{primary.areas[1].name}</h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: primary.areas[1].summary,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="area-outer-container">
            <div className="area-container">
              <h4 className="eyebrow">{primary.areas[0].name} at McKinsey</h4>
              <div className="profile">
                <Img
                  fluid={imageProfileMobile.childImageSharp.fluid}
                  className="profile-image hide-for-desktop"
                />
                <Img
                  fluid={imageProfile.childImageSharp.fluid}
                  className="profile-image hide-for-mobile"
                />
                <div className="profile-content">
                  <p className="blockquote">{primary.profiles[0].quote}</p>
                  <div className="profile-inner-content">
                    <p className="profile-name">
                      {primary.profiles[0].firstName}{' '}
                      {primary.profiles[0].lastName}
                    </p>
                    <p className="profile-role">
                      {primary.profiles[0].title},{' '}
                      {primary.profiles[0].location}
                    </p>
                    <div
                      className="profile-summary"
                      dangerouslySetInnerHTML={{
                        __html: primary.profiles[0].summary,
                      }}
                    />
                    <a
                      href={primary.profiles[0].url}
                      className="cta link-with-arrow explore-profile-role-cta"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Learn more about {primary.profiles[0].firstName}'s role
                    </a>
                  </div>
                </div>
              </div>
              <div className="explore-roles explore-area-roles">
                <div className="container">
                  <h3 className="eyebrow">
                    Explore {primary.areas[0].name} roles at McKinsey
                  </h3>

                  <Slider>
                    <div className="role">
                      <Img fluid={imageRoleOne.childImageSharp.fluid} />
                      <div className="role-content">
                        <h4 className="role-title">{primary.roles[0].name}</h4>
                        <p>{primary.roles[0].description}</p>
                      </div>
                    </div>
                    <div className="role">
                      <Img fluid={imageRoleTwo.childImageSharp.fluid} />
                      <div className="role-content">
                        <h4 className="role-title">{primary.roles[1].name}</h4>
                        <p>{primary.roles[1].description}</p>
                      </div>
                    </div>
                    <div className="role">
                      <Img fluid={imageRoleThree.childImageSharp.fluid} />
                      <div className="role-content">
                        <h4 className="role-title">{primary.roles[2].name}</h4>
                        <p>{primary.roles[2].description}</p>
                      </div>
                    </div>
                  </Slider>

                  <div className="roles-container">
                    <div className="role">
                      <Img fluid={imageRoleOne.childImageSharp.fluid} />
                      <div className="role-content">
                        <h4 className="role-title">{primary.roles[0].name}</h4>
                        <p>{primary.roles[0].description}</p>
                      </div>
                    </div>
                    <div className="role">
                      <Img fluid={imageRoleTwo.childImageSharp.fluid} />
                      <div className="role-content">
                        <h4 className="role-title">{primary.roles[1].name}</h4>
                        <p>{primary.roles[1].description}</p>
                      </div>
                    </div>
                    <div className="role">
                      <Img fluid={imageRoleThree.childImageSharp.fluid} />
                      <div className="role-content">
                        <h4 className="role-title">{primary.roles[2].name}</h4>
                        <p>{primary.roles[2].description}</p>
                      </div>
                    </div>
                  </div>

                  <a
                    href={primary.searchUrl}
                    className="cta link-with-arrow explore-all-roles-cta"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Explore all {primary.areas[0].name} roles
                  </a>
                </div>
              </div>
            </div>
            <div className="area-container">
              <h4 className="eyebrow">{primary.areas[1].name} at McKinsey</h4>
              <div className="profile">
                <Img
                  fluid={imageProfileAlternateMobile.childImageSharp.fluid}
                  className="profile-image hide-for-desktop"
                />
                <Img
                  fluid={imageProfileAlternate.childImageSharp.fluid}
                  className="profile-image hide-for-mobile"
                />
                <div className="profile-content">
                  <p className="blockquote">{primary.profiles[1].quote}</p>
                  <div className="profile-inner-content">
                    <p className="profile-name">
                      {primary.profiles[1].firstName}{' '}
                      {primary.profiles[1].lastName}
                    </p>
                    <p className="profile-role">
                      {primary.profiles[1].title},{' '}
                      {primary.profiles[1].location}
                    </p>
                    <div
                      className="profile-summary"
                      dangerouslySetInnerHTML={{
                        __html: primary.profiles[1].summary,
                      }}
                    />
                    <a
                      href={primary.profiles[1].url}
                      className="cta link-with-arrow explore-profile-role-cta"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Learn more about {primary.profiles[1].firstName}'s role
                    </a>
                  </div>
                </div>
              </div>
              {primary.functions !== null && (
                <div className="explore-functions">
                  <div className="container">
                    <h3 className="eyebrow">
                      Functions within {primary.areas[1].name}
                    </h3>
                    <ul className="functions-list">
                      {primary.functions.map(({ node }) => (
                        <li className="function" key={node.name}>
                          <h4 className="function-name">{node.name}</h4>
                          <p className="function-description">
                            {node.description}
                          </p>
                          <a
                            className="cta link-with-arrow function-link"
                            href={node.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Explore roles
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
              <div className="explore-roles explore-area-roles">
                <div className="container">
                  <h3 className="eyebrow">
                    Explore {primary.areas[1].name} roles at McKinsey
                  </h3>

                  <Slider>
                    <div className="role">
                      <Img
                        fluid={imageRoleAlternateOne.childImageSharp.fluid}
                      />
                      <div className="role-content">
                        <h4 className="role-title">
                          {primary.rolesAlternate[0].name}
                        </h4>
                        <p>{primary.rolesAlternate[0].description}</p>
                      </div>
                    </div>
                    <div className="role">
                      <Img
                        fluid={imageRoleAlternateTwo.childImageSharp.fluid}
                      />
                      <div className="role-content">
                        <h4 className="role-title">
                          {primary.rolesAlternate[1].name}
                        </h4>
                        <p>{primary.rolesAlternate[1].description}</p>
                      </div>
                    </div>
                    <div className="role">
                      <Img
                        fluid={imageRoleAlternateThree.childImageSharp.fluid}
                      />
                      <div className="role-content">
                        <h4 className="role-title">
                          {primary.rolesAlternate[2].name}
                        </h4>
                        <p>{primary.rolesAlternate[2].description}</p>
                      </div>
                    </div>

                  </Slider>

                  <div className="roles-container">
                    <div className="role">
                      <Img
                        fluid={imageRoleAlternateOne.childImageSharp.fluid}
                      />
                      <div className="role-content">
                        <h4 className="role-title">
                          {primary.rolesAlternate[0].name}
                        </h4>
                        <p>{primary.rolesAlternate[0].description}</p>
                      </div>
                    </div>
                    <div className="role">
                      <Img
                        fluid={imageRoleAlternateTwo.childImageSharp.fluid}
                      />
                      <div className="role-content">
                        <h4 className="role-title">
                          {primary.rolesAlternate[1].name}
                        </h4>
                        <p>{primary.rolesAlternate[1].description}</p>
                      </div>
                    </div>
                    <div className="role">
                      <Img
                        fluid={imageRoleAlternateThree.childImageSharp.fluid}
                      />
                      <div className="role-content">
                        <h4 className="role-title">
                          {primary.rolesAlternate[2].name}
                        </h4>
                        <p>{primary.rolesAlternate[2].description}</p>
                      </div>
                    </div>
                  </div>
                  <a
                    href={primary.searchUrl}
                    className="cta link-with-arrow explore-all-roles-cta"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Explore all {primary.areas[1].name} roles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {primary.areas === null && (
        <>
          <div className="explore-roles">
            <div className="container">
              <h3 className="eyebrow">
                Explore {primary.name} roles at McKinsey
              </h3>

              <Slider>
                <div className="role">
                  <Img fluid={imageRoleOne.childImageSharp.fluid} />
                  <div className="role-content">
                    <h4 className="role-title">{primary.roles[0].name}</h4>
                    <p>{primary.roles[0].description}</p>
                  </div>
                </div>
                <div className="role">
                  <Img fluid={imageRoleTwo.childImageSharp.fluid} />
                  <div className="role-content">
                    <h4 className="role-title">{primary.roles[1].name}</h4>
                    <p>{primary.roles[1].description}</p>
                  </div>
                </div>
                <div className="role">
                  <Img fluid={imageRoleThree.childImageSharp.fluid} />
                  <div className="role-content">
                    <h4 className="role-title">{primary.roles[2].name}</h4>
                    <p>{primary.roles[2].description}</p>
                  </div>
                </div>
              </Slider>

              <div className="roles-container">
                <div className="role">
                  <Img fluid={imageRoleOne.childImageSharp.fluid} />
                  <div className="role-content">
                    <h4 className="role-title">{primary.roles[0].name}</h4>
                    <p>{primary.roles[0].description}</p>
                  </div>
                </div>
                <div className="role">
                  <Img fluid={imageRoleTwo.childImageSharp.fluid} />
                  <div className="role-content">
                    <h4 className="role-title">{primary.roles[1].name}</h4>
                    <p>{primary.roles[1].description}</p>
                  </div>
                </div>
                <div className="role">
                  <Img fluid={imageRoleThree.childImageSharp.fluid} />
                  <div className="role-content">
                    <h4 className="role-title">{primary.roles[2].name}</h4>
                    <p>{primary.roles[2].description}</p>
                  </div>
                </div>
              </div>
              <a
                href={primary.searchUrl}
                className="cta link-with-arrow explore-all-roles-cta"
                target="_blank"
                rel="noopener noreferrer"
              >
                Explore all {primary.name} roles
              </a>
            </div>
          </div>
          <div className="explore-more">
            <div className="profile">
              <Img
                fluid={imageProfileMobile.childImageSharp.fluid}
                className="profile-image hide-for-desktop"
              />
              <Img
                fluid={imageProfile.childImageSharp.fluid}
                className="profile-image hide-for-mobile"
              />
              <div className="profile-content">
                <p className="blockquote">{primary.profiles[0].quote}</p>
                <div className="profile-inner-content">
                  <p className="profile-name">
                    {primary.profiles[0].firstName}{' '}
                    {primary.profiles[0].lastName}
                  </p>
                  <p className="profile-role">
                    {primary.profiles[0].title}, {primary.profiles[0].location}
                  </p>
                  <div
                    className="profile-summary"
                    dangerouslySetInnerHTML={{
                      __html: primary.profiles[0].summary,
                    }}
                  />
                  <a
                    href={primary.profiles[0].url}
                    className="cta link-with-arrow explore-profile-role-cta"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn more about {primary.profiles[0].firstName}'s role
                  </a>
                </div>
              </div>
            </div>
            <div className="considerations">
              <div className="container">
                <h3 className="eyebrow">Considerations before you apply</h3>
                <ol>
                  <li>
                    <dt>Keywords</dt>
                    <dd>
                      Use keyword search to identify specific opportunities that
                      match your experience.
                    </dd>
                  </li>
                  <li>
                    <dt>Qualifications</dt>
                    <dd>
                      Review qualifications and requirements in each job posting
                      to confirm the position is a good fit for your skills.
                    </dd>
                  </li>
                  <li>
                    <dt>Languages</dt>
                    <dd>
                      Keep in mind that fluency in the local language—and
                      fluency in English—is a requirement of most positions.
                    </dd>
                  </li>
                </ol>
              </div>
            </div>
            <div className="search-opportunities">
              <div className="container">
                <a
                  href={primary.searchUrl}
                  className="btn btn-primary btn-fill search-cta"
                >
                  <span>Search for opportunities in {primary.name}</span>
                </a>
              </div>
            </div>
          </div>
        </>
      )}

      {primary.areas !== null && (
        <>
          <div className="explore-more">
            <div className="considerations">
              <div className="container">
                <h3 className="eyebrow">Considerations before you apply</h3>
                <ol>
                  <li>
                    <dt>Keywords</dt>
                    <dd>
                      Use keyword search to identify specific opportunities that
                      match your experience.
                    </dd>
                  </li>
                  <li>
                    <dt>Qualifications</dt>
                    <dd>
                      Review qualifications and requirements in each job posting
                      to confirm the position is a good fit for your skills.
                    </dd>
                  </li>
                  <li>
                    <dt>Languages</dt>
                    <dd>
                      Keep in mind that fluency in the local language—and
                      fluency in English—is a requirement of most positions.
                    </dd>
                  </li>
                </ol>
              </div>
            </div>
            <div className="search-opportunities">
              <div className="container">
                <a
                  href={primary.searchUrl}
                  className="btn btn-primary btn-fill search-cta"
                >
                  <span>Search for opportunities in {primary.name}</span>
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
    <div className="secondary-content">
      {secondary !== null && (
        <>
          <h4 className="secondary-content-heading">
            You may also be interested in the following:
          </h4>
          <div className="other-paths">
            <div className="career-path">
              <Img
                fluid={secondaryImageMobile.childImageSharp.fluid}
                className="career-path-image hide-for-desktop"
              />
              <div className="career-path-content">
                <h2>Explore {secondary.name}</h2>
                <p className="summary">{secondary.summary}</p>
                <a
                  href={'/spContent/CareersQuiz/explore/' + secondary.name.toLowerCase() + '/index.html'}
                  className="btn btn-primary btn-fill"
                >
                  Learn More
                </a>
              </div>
            </div>
            <div className="career-path">
              <Img
                fluid={tertiaryImageMobile.childImageSharp.fluid}
                className="career-path-image hide-for-desktop"
              />
              <div className="career-path-content">
                <h2>Explore {tertiary.name}</h2>
                <p className="summary">{tertiary.summary}</p>
                <a
                  href={'/spContent/CareersQuiz/explore/' + tertiary.name.toLowerCase() + '/index.html'}
                  className="btn btn-primary btn-fill"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </>
      )}
      <Footer secondary={secondary} />
    </div>
  </section>
)

export const careerDetailsFragment = graphql`
  fragment careerDetails on CareersJson {
    id
    name
    summary
    expanded
    areas {
      name
      summary
    }
    roles {
      image
      name
      description
    }
    functions {
      node {
        name
        description
        url
      }
    }
    rolesAlternate {
      image
      name
      description
    }
    profiles {
      quote
      firstName
      lastName
      title
      location
      summary
      url
    }
    searchUrl
  }
`

export const careerSummaryFragment = graphql`
  fragment careerSummary on CareersJson {
    id
    name
    summary
  }
`

export default Career
